import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

const OrgCsrModal = () => {
    const navigate = useNavigate();
    const { userToken, sharedObject, SetSharedObject } = useUserStore(
        (state) => ({
            userToken: state.userToken,
            sharedObject: state.sharedObject,
            SetSharedObject: state.SetSharedObject,
        })
    );
    const [answers, setAnswers] = useState(null);
    const [processing, SetProcessing] = useState(false);
    const [errCreateMsg, SetErrCreateMsg] = useState(false);
    const [msg, SetMsg] = useState(false);
    const statusRef = useRef(null);
    const firstFocusRef = useRef(null);
    const previousFocusRef = useRef(null);
    const setAnswer = async (questionId, answer, questtwo) => {
        if (questionId === "uploadCSR") {
            await setAnswers({
                ...answers,
                [questionId]: answer,
                postCSR: false,
                orgCSRText: "",
            });
        } else if (questionId === "postCSR") {
            await setAnswers({
                ...answers,
                [questionId]: answer,
                uploadCSR: false,
            });
            $("#exampleFormControlFile1").val("");
        } else {
            await setAnswers({
                ...answers,
                [questionId]: answer,
            });
        }
    };
    useEffect(() => {
        if (sharedObject.CSRUploadPage !== "fake") SetErrCreateMsg(false);
        setAnswers(sharedObject.orgActionObj);
    }, [sharedObject.orgActionObj, sharedObject.CSRUploadFlag]);

    // Bootstrap modal events for focus management
    useEffect(() => {
    const modalEl = document.getElementById("orgCSRModal");
    if (!modalEl) return;

    const onShown = () => {
      previousFocusRef.current = document.activeElement;
      setTimeout(() => firstFocusRef.current?.focus(), 50);
    };
    const onHidden = () => {
      previousFocusRef.current?.focus();
    };

    modalEl.addEventListener("shown.bs.modal", onShown);
    modalEl.addEventListener("hidden.bs.modal", onHidden);
    return () => {
      modalEl.removeEventListener("shown.bs.modal", onShown);
      modalEl.removeEventListener("hidden.bs.modal", onHidden);
    };
  }, []);

  // FIX: Focus trap
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      closeModal();
      return;
    }
    if (e.key !== "Tab") return;

    const modal = e.currentTarget;
    const focusable = modal.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

    const UpdateCSR = async () => {
        SetErrCreateMsg(false);
        SetProcessing(true);
        const formData = new FormData();
        const fileField = document.querySelector('input[type="file"]');
        formData.append("Files", fileField.files[0]);

        if ((fileField.files[0] && answers?.uploadCSR === true) || answers?.postCSR === true) {
            let call =
                "/organization/PostRequest?orgId=" +
                answers.id +
                "&csrText=" +
                answers.orgCSRText;
            const res = await CallAPI(call, formData, "post", userToken, true);
            await SetSharedObject("ResponseCode", res.code);
            if (res.status === "SUCCESS") {
                SetProcessing(false);
                CloseCSRmodal();
                let det = { ...sharedObject.orgActionObj, isCsrOrg: true };
                SetSharedObject("orgActionObj", det);
                if (sharedObject.CSRUploadPage === "Enable")
                    SetSharedObject("CSRUploadFlag", true);
                if (statusRef.current)
                    statusRef.current.textContent = "CSR submitted successfully.";
            } else if (res.status === "SERVERERROR") {
                SetProcessing(false);
                if (sharedObject.CSRUploadPage === "Enable") {
                    SetSharedObject("CSRUploadPage", "fake");
                    SetSharedObject("CSRUploadFlag", false);
                }

                let msg = res.data;
                if (Object.keys(msg).length > 0 && msg.constructor === Object) {
                    let str = "<ul>";
                    for (let el in msg) {
                        str += `<li>${el}</li>`;
                    }
                    str += "</ul>";
                    SetMsg(str);
                } else {
                    SetMsg(msg);
                }

                SetErrCreateMsg(true);
                SetProcessing(false);
                if (statusRef.current)
                    statusRef.current.textContent = "Submission failed. Please review the errors and try again.";
            }
        } else {
            if (answers?.uploadCSR === true) {
                let msg = "Please include a CSR file";
                SetMsg(msg);
                SetErrCreateMsg(true);
                SetProcessing(false);
            } else if ((answers?.postCSR === false && answers?.uploadCSR === false) || (!answers?.postCSR && !answers?.uploadCSR)) {
                let msg = "Please select an option";
                SetMsg(msg);
                SetErrCreateMsg(true);
                SetProcessing(false);
            }
        }
    };

    const closeModal = (modalId) => {
        SetSharedObject("CSRUploadFlag", sharedObject.CSRUploadFlag);
        SetErrCreateMsg(false);
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        $(`#${modalId}`).modal('hide');
    };

    const CloseCSRmodal = () => closeModal('orgCSRModal');

    return (
        <div className="OrgCsrModal">
            <div
                ref={statusRef}
                role="status"
                aria-live="polite"
                aria-atomic="true"
                className="sr-only"
            />
            <div
                className="modal fade"
                id="orgCSRModal"
                data-backdrop="static"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="csr-modal-title"
                aria-describedby="csr-modal-body"
                aria-modal="true"
                onKeyDown={handleKeyDown}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title" id="csr-modal-title">
                                Upload or Post CSR
                            </h3>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close Upload or Post CSR Dialog"
                                onClick={(el) => {
                                    SetSharedObject("CSRUploadFlag", sharedObject.CSRUploadFlag);
                                    SetErrCreateMsg(false);
                                    CloseCSRmodal();
                                }}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div id="csr-modal-body" className="descript2-container">
                                The CSR (Certificate Signing Request) request below must match
                                the following values for CN, O, and OU in the Subject Name
                                otherwise the request will be rejected.
                            </div>
                            <dl className="csr-values">
                                <div>
                                    <dt>CN:</dt>
                                    <dd className="spacer-margin5">{answers?.organizationName}</dd>
                                </div>
                                <div>
                                <dt>O:</dt>
                                    <dd className="spacer-margin5">{answers?.id}</dd>
                                </div>
                                <div>
                                <dt>OU:</dt>
                                    <dd className="spacer-margin5">{answers?.vendorId}</dd>
                                </div>
                            </dl>
                            <div className="descript2-container">
                                When you provide new CSR, your existing certificate (if any) will
                                be revoked and replaced with the new one.
                            </div>
                            <fieldset className="upload-csr">
                                <legend className="sr-only">CSR submission method</legend>
                                <input
                                    type="checkbox"
                                    className="form-control sp-margin5"
                                    ref={firstFocusRef}
                                    id="uploadCSR"
                                    name="uploadCSR"
                                    checked={answers?.uploadCSR}
                                    value={answers?.uploadCSR}
                                    onChange={(el) => {
                                        setAnswer("uploadCSR", el.target.checked);
                                    }}
                                />
                                <label htmlFor="uploadCSR">Upload CSR</label>
                                <div className="form-group" >
                                    <label htmlFor="exampleFormControlFile1" className="sr-only">
                                        Select CSR file
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control-file cblu-clr "
                                        id="exampleFormControlFile1"
                                        onClick={(el) => {
                                            SetMsg(false);
                                            SetErrCreateMsg(false);
                                        }}
                                    />
                                </div>
                                <div>
                                    <input
                                        type="checkbox"
                                        className="form-control sp-margin5"
                                        id="postCSR"
                                        name="postCSR"
                                        checked={answers?.postCSR}
                                        value={answers?.postCSR}
                                        onChange={(el) => {
                                            setAnswer("postCSR", el.target.checked);
                                            SetMsg(false);
                                            SetErrCreateMsg(false);
                                        }}
                                    />
                                    <label htmlFor="postCSR">Post CSR</label>
                                    <label htmlFor="orgCSRText" className="sr-only">
                                        CSR text
                                    </label>
                                    <textarea
                                        id="orgCSRText"
                                        name="orgCSRText"
                                        className="form-control"
                                        hidden={!answers?.postCSR}
                                        value={answers?.orgCSRText}
                                        onChange={(el) => {
                                            setAnswer("orgCSRText", el.target.value);
                                        }}
                                    ></textarea>
                                </div>
                                {errCreateMsg ? (
                                    <div 
                                        className={`alert alert-danger`} 
                                        role="alert" aria-live="assertive" 
                                        aria-atomic="true"
                                    >
                                        {msg}
                                    </div>
                                ) : null}
                            </fieldset>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={(e) => UpdateCSR()}
                                disabled={processing}
                            >
                                {processing ? "Processing..." : "Submit"}
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                disabled={processing}
                                onClick={(el) => {
                                    SetSharedObject("CSRUploadFlag", sharedObject.CSRUploadFlag);
                                    SetErrCreateMsg(false);
                                    CloseCSRmodal();
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrgCsrModal;
